import * as types from "./types";

const initialState = {
  clubsData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CLUBS_DATA: {
      return {
        ...state,
        clubsData: action?.payload?.data,
      };
    }
    default:
      return state;
  }
};

export default reducer;
